const localStorage = {
  SLIDER_SCREEN: 'SLIDER_SCREEN',
};
export default localStorage;